






import { Component, Vue } from "vue-property-decorator"

const DEFAULT_LAYOUT = "default"

@Component
export default class App extends Vue {
  get layout(): string {
    return (this.$route.meta.layout || DEFAULT_LAYOUT) + "-layout"
  }
}
